import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { PanelTypeDirective } from './panel-type.directive';
import { WorkspaceService } from './workspace.service';

@Component({
  selector: 'ez-workspace',
  templateUrl: './workspace.component.html',
  styleUrls: ['./workspace.component.scss'],
  standalone: false,
})
export class WorkspaceComponent implements OnInit, OnDestroy {
  @ViewChild(PanelTypeDirective, { static: true }) panelType: PanelTypeDirective;

  readonly #workspaceService = inject(WorkspaceService);
  #componentSubscription: Subscription;

  constructor() {
    this.#componentSubscription = this.#workspaceService.changeComponent.subscribe(() => {
      this.#showPanel();
    });
  }

  ngOnInit(): void {
    this.#showPanel();
  }

  ngOnDestroy(): void {
    this.#componentSubscription.unsubscribe();
  }

  #showPanel(): void {
    const viewContainerRef = this.panelType.viewContainerRef;

    this.#workspaceService.viewContainerRef = viewContainerRef;

    viewContainerRef.clear();

    viewContainerRef.createComponent(this.#workspaceService.currentComponentType);
  }
}
